import { useMutation, useQueryClient } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

type ActivationParams = {
  userId: string
}

export const useUserActivation = () => {
  const queryClient = useQueryClient()

  const activateUser = useMutation({
    mutationFn: async ({ userId }: ActivationParams) => {
      const { data, error } = await supabase.functions.invoke("activate-user", {
        body: { userId },
      })

      if (error) {
        throw new Error(error.message)
      }

      return data
    },
    onSuccess: () => {
      // Invalidate and refetch the users query to update the UI
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })

  const deactivateUser = useMutation({
    mutationFn: async ({ userId }: ActivationParams) => {
      const { data, error } = await supabase.functions.invoke("deactivate-user", {
        body: { userId },
      })

      if (error) {
        throw new Error(error.message)
      }

      return data
    },
    onSuccess: () => {
      // Invalidate and refetch the users query to update the UI
      queryClient.invalidateQueries({ queryKey: ["users"] })
    },
  })

  return {
    activateUser,
    deactivateUser,
  }
}
